import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { CustomButton, CustomTable } from '../../shared/uiComponents';
import { useCheckPermission, useScreenWidth } from '../../shared/Helpers/hooks';
import SearchBar from '../../components/SearchBar';
import { Container, Header } from '../../components/StyledComponents';
import { AdminTypes } from '../../components/Menu';
import { PERMISSIONS } from '../../App/constants';
import MobileView from './mobileView';
import { Headers, TableBody } from './tableInfo';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getAdmins } from '../../redux/State/userSlice';
import { PageHeader } from '../../components/PageHeader';
import { PlusIcon } from '../../shared/Assets/svg';
import { Settings } from '../../shared/Assets/menuIcons';

const Admins = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<DispatchProperties>();
	const { permissionGranted } = useCheckPermission(PERMISSIONS.USER.CREATE);

	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const [params] = useSearchParams();

	const page = params.get('page') || '1';
	const pageSize = params.get('pageSize') || '8';
	const orderBy = params.get('orderBy') || '';
	const direction = params.get('direction') || '';
	const searchString = params.get('search') || '';
	const section = params.get('status');

	const admins = useSelector((state) => state.user.admins);
	const loading = useSelector((state) => state.user.loading);

	useEffect(() => {
		dispatch(getAdmins({ page, pageSize, orderBy, direction, searchString, section }));
	}, [page, pageSize, orderBy, direction, searchString, section, dispatch]);

	const addAdminHandler = () => {
		window.localStorage.setItem('formType', AdminTypes[0]);
		navigate('/admin/new');
	};

	const headerContent = (
		<>
			<SearchBar style={{ marginTop: 0 }} />
			{permissionGranted && <CustomButton title="Add Admin" onClick={addAdminHandler} startIcon={<PlusIcon />} />}
		</>
	);

	return (
		<>
			{isMobile ? (
				<MobileView {...admins} />
			) : (
				<Container>
					<Header>
						<PageHeader icon={<Settings />} title="Admin" isInContainer headerContent={headerContent} />
					</Header>
					<CustomTable headers={Headers} data={admins} TableBody={TableBody} loading={loading} />
				</Container>
			)}
		</>
	);
};

export default Admins;
